import Section from "../section";
import { defer, sprint, parse } from "../utils/core";
import Path from "../utils/path";
import Url from "../utils/url";
import ExEpubCFI from "./epubcfi";

class ExSection extends Section{
	constructor(item, hooks, book){
		super(item, hooks);

		//加入token
		this.token = item.token;

		//加入book
		this.book = book;

		//待轉換cpct書籤
		this._cpctBookmark = [];

		//cpct書籤轉換中繼物件
		this._cpctConventObject = null;

		//目前前景是否顯示
		this._isNowDisplay = false;

		//目前背景是否顯示
		this._isBgNowDisplay = false;
	}

	checkIsNowDisplay(startIndex, endIndex){
		this._isNowDisplay = (this.index === startIndex || this.index === endIndex);
	}

	checkIsBgNowDisplay(startIndex, endIndex){
		this._isBgNowDisplay = (this.index === startIndex || this.index === endIndex);
	}

	addCpctBookmark(cpctBookmark){
		this._cpctBookmark.push(cpctBookmark);
	}

	checkCpctBookmark(cpctBookmark){
		let i = 0;
		let old_annotation;
		while (i < this._cpctBookmark.length) {
			if(JSON.stringify(this._cpctBookmark[i]) === JSON.stringify(cpctBookmark)){
				old_annotation = this._cpctBookmark[i];
				break;
			}
			i++;
		}
		return (old_annotation) ? old_annotation : false;
	}

	/**
	 * Load the section from its url
	 * @param  {method} [_request] a request method to use for loading
	 * @return {document} a promise with the xml document
	 */
	load(_request){
		var request = _request || this.request || Request;
		var loading = new defer();
		var loaded = loading.promise;


		if(this.contents) {
			loading.resolve(this.contents);
		} else {

			let spineBlob = this.book.getBlobCache(this.url);
			if(spineBlob){
				let blobLoading, blobLoaded, blobReader;
				if(spineBlob.text){
					blobLoaded = spineBlob.text();
				}else{
					blobLoading = new defer();
					blobLoaded = blobLoading.promise;
					blobReader = new FileReader();
					blobReader.addEventListener("load", function () {
						blobLoading.resolve(blobReader.result);
					});
					blobReader.addEventListener("error", function (error) {
						blobLoading.reject(error);
					});
					blobReader.readAsText(spineBlob);
				}


				blobLoaded.then(function(spineText){
					return parse(spineText, spineBlob.type);
				}.bind(this))
				.then(function(xml){
				
					this.document = xml;
					this.contents = xml.documentElement;

					//取得 hash cfi
					this.chechHash();
					
					return this.hooks.content.trigger(this.document, this);
				}.bind(this))
				.then(function(xml){
					//轉換cpct書籤
					if(this._cpctBookmark.length && !this._cpctConventObject){
						this._cpctConventObject = {};
						$.each(this._cpctBookmark, (index, cpctBookmark)=>{
							this._cpctConventObject[cpctBookmark.uuid] = cpctBookmark.cfi;
						});
						let getCFI = this.book.locations.generateCFIFromCpct(`epubjs-task-convent-bookmark-cpct-from-setion-${this.index}`, this._cpctConventObject);
						if (getCFI && getCFI.then && typeof getCFI.then === "function") {
							return getCFI.then((cfi)=>{
								$.each(this._cpctBookmark, (index, cpctBookmark)=>{
									let newCFI = cfi[cpctBookmark.uuid];
									if(newCFI){
										cpctBookmark.cfi = newCFI;
										cpctBookmark.cfieven = newCFI;
										this.book.rendition.annotations.bookmark(cpctBookmark.cfi, {"cfieven":cpctBookmark.cfieven, "uuid":cpctBookmark.uuid, "highlight_text":cpctBookmark.highlight_text, "page":cpctBookmark.page});
									}
								});
								this._cpctBookmark = [];
								return xml;
							});
						}else{
							return xml;
						}
					}else{
						return xml;
					}
				}.bind(this))
				.then(function(){
					loading.resolve(this.contents);
				}.bind(this))
				.catch(function(error){
					loading.reject(error);
				});

			}else{
				//加入downloadToken參數
				let requestParam = undefined;
				if(this.token !== ""){
					requestParam = {
						downloadToken:this.token,
						//isDecodefault:1,
						//isfault:4
					};
				}

				request(this.url, requestParam)
					.then(function(xml){
						return this.xmlAdjust(this.url, xml, this.book);
					}.bind(this))
					.then(function(xml){
						
						this.document = xml;
						this.contents = xml.documentElement;

						//取得 hash cfi
						this.chechHash();
						
						return this.hooks.content.trigger(this.document, this);
					}.bind(this))
					.then(function(xml){
						//轉換cpct書籤
						if(this._cpctBookmark.length && !this._cpctConventObject){
							this._cpctConventObject = {};
							$.each(this._cpctBookmark, (index, cpctBookmark)=>{
								this._cpctConventObject[cpctBookmark.uuid] = cpctBookmark.cfi;
							});
							let getCFI = this.book.locations.generateCFIFromCpct(`epubjs-task-convent-bookmark-cpct-from-setion-${this.index}`, this._cpctConventObject);
							if (getCFI && getCFI.then && typeof getCFI.then === "function") {
								return getCFI.then((cfi)=>{
									$.each(this._cpctBookmark, (index, cpctBookmark)=>{
										let newCFI = cfi[cpctBookmark.uuid];
										if(newCFI){
											cpctBookmark.cfi = newCFI;
											cpctBookmark.cfieven = newCFI;
											this.book.rendition.annotations.bookmark(cpctBookmark.cfi, {"cfieven":cpctBookmark.cfieven, "uuid":cpctBookmark.uuid, "highlight_text":cpctBookmark.highlight_text, "page":cpctBookmark.page});
										}
									});
									this._cpctBookmark = [];
									return xml;
								});
							}else{
								return xml;
							}
						}else{
							return xml;
						}
					}.bind(this))
					.then(function(){
						loading.resolve(this.contents);
					}.bind(this))
					.catch(function(error){
						loading.reject(error);
					});
			}
		}

		return loaded;
	}

	chechHash(){
		if(this.hash){
			for(const hashItem of this.hash){
				if(hashItem.hash !== ""){
					let element = this.document.getElementById(hashItem.hash);
					hashItem.cfi = this.cfiFromElement(element);
				}else{
					let body = this.document.getElementsByTagName('body')[0];
					hashItem.cfi = this.cfiFromElement(body);
				}
			}
		}
	}

	getSectionHash(){
		return this.hash || null;
	}

	/**
	 * Get a CFI from a Range in the Section
	 * @param  {range} _range
	 * @return {string} cfi an EpubCFI string
	 */
	 cfiFromRange(_range) {
		return new ExEpubCFI(_range, this.cfiBase).toString();
	}

	/**
	 * Get a CFI from an Element in the Section
	 * @param  {element} el
	 * @return {string} cfi an EpubCFI string
	 */
	cfiFromElement(el) {
		return new ExEpubCFI(el, this.cfiBase).toString();
	}

	xmlAdjust(spineUrl, xml, book){

		let doc = xml;

		//建立 promise 陣列
		let promises = [];

		//opf url
		let opfUrl = new URL(this.book.container.packagePath, this.book.url.href);

		//是否有直橫書模板
		if(this.book.rendition._layout.name !== "pre-paginated"){
			$(".vrtl, .hltr", doc).each((index, element) => {
				this.book.templateInfo.isTemplate = true;
				this.book.templateInfo.defaultClass = ($(element).hasClass( "vrtl" )) ? 'vrtl' : 'hltr' ;
				this.book.templateInfo.rootElement.push(element);
			});
		}

		//加入body 禁止右鍵、剪下、貼上
		$("body",doc).each((index, element) => {
			$(element).attr("oncopy", "return false").attr("oncut", "return false");
		});

		//調整table
		this.adjustTable(doc);

		//調整video, audio
		this.adjustMedia(doc);

		//position: absolute 的 element 的父系若沒有加上 position: relative 會造成 genPage 和 genTTS 計算頁數出現落差
		//以調整書籍方式處理, 所以暫不添加規則
		//$('*[style*="position: absolute"]', doc).parent().css("position", "relative");
		
		$("*[*|href],[src]",doc).each((index, element) => {
			let linkData = [];

			//href xlink:href src link
			let defaultLinkAttr;
			if($(element).attr("href")){
				defaultLinkAttr = "href";
			}else if($(element).attr("xlink:href")){
				defaultLinkAttr = "xlink:href";
			}else{
				defaultLinkAttr = "src";
			}
			let defaultLink = $(element).attr(defaultLinkAttr);
			linkData.push({'link':defaultLink, 'linkAttr':defaultLinkAttr});

			//poster link
			let posterLink = null;
			if($(element).attr("poster")){
				posterLink = $(element).attr("poster");
				linkData.push({'link':posterLink, 'linkAttr':'poster'});
			}

			linkData.forEach((linkItem, index)=>{
				let linkAttr = linkItem.linkAttr;
				let link = linkItem.link;
				let manifestIndex;
				
				if(this.book.resources.urls.indexOf(link) !== -1){
					manifestIndex = this.book.resources.urls.indexOf(link);
				}else{
					if(link && link !== ""){
						let fixLink = link.replace(/(\.+)\//gi, "");
						manifestIndex = this.book.resources.urls.indexOf(fixLink);
					}
					if(typeof manifestIndex == "undefined" || manifestIndex === -1){
						let tarUrl = new URL(link, spineUrl);
						let relative = new Path(opfUrl.href.replace(this.book.url.href, "")).relative(tarUrl.href.replace(this.book.url.href, ""));
						manifestIndex = this.book.resources.urls.indexOf(relative);
					}
				}	
				if(typeof manifestIndex !== "undefined" && manifestIndex !== -1){
					let getUrl;
					let assetsData = this.book.resources.assets[manifestIndex];	
					let baseUrl = `${this.book.settings.baseUrl}${this.book.container.directory}/`;
					let tarUrl = new URL(baseUrl+assetsData["href"]);
					let checksum = this.book.settings.checksum;
					let downloadToken = this.book.settings.downloadToken;
					let haveToAddChecksumAndDownloadToken = (this.book.settings.encryptType && this.book.settings.encryptType === "enc01");
					if(haveToAddChecksumAndDownloadToken){
						// web 正式書才會執行
						//取得頁面中所有 manifest 連結, 並加入 checksum 和 DownloadToken
						//書內資源
						if(tarUrl.searchParams == undefined){
							let s = [];
							s.push(tarUrl.search);
							s.push("checksum="+checksum);
							s.push("DownloadToken="+downloadToken);
							getUrl = (tarUrl.search == "")?s.join("&").replace("&","?"):s.join("&");  
						}else{
							tarUrl.searchParams.append("checksum",checksum);
							tarUrl.searchParams.append("DownloadToken",downloadToken);
							getUrl = baseUrl+assetsData["href"]+tarUrl.search;
						}
					}else{
						// web 試閱書 和 APP 才會執行
						getUrl = tarUrl.href;
					}

					let blobTagName = [];
					for (const type in this.book.rendition.settings.manifestCache) {
						if(this.book.rendition.settings.manifestCache[type]){
							switch(type){
								case "css": blobTagName.push("link"); break;
								case "img": blobTagName.push("img","image"); break;
								case "media": blobTagName.push("video","audio","source"); break;
							}
						}
					}

					if(blobTagName.includes(element.tagName.toLowerCase())){
						let linkBlob = book.getBlobCache(getUrl);
						if(linkBlob){
							$(element).attr(linkAttr, linkBlob);
						}else{
							let dfd = $.Deferred();
							promises.push(dfd);
							$.ajax({
								xhrFields: { withCredentials: true },
								url: getUrl,
								type: "GET",
								//dataType: assetsData.type,
								//cache: false,
								xhr: function () {
									var xhr = new XMLHttpRequest();
									xhr.responseType= "blob";
									return xhr;
								}
								,success: function(blob){
									let blobLoading, blobLoaded, blobReader;
									let blobTypeAr =  blob.type.split(";");
									let blobLink;
									switch (blobTypeAr[0]){
									case "text/css":
										if(blob.text){
											blobLoaded = blob.text();
										}else{
											blobLoading = new defer();
											blobLoaded = blobLoading.promise;
											blobReader = new FileReader();
											blobReader.addEventListener("load", function () {
												blobLoading.resolve(blobReader.result);
											});
											blobReader.addEventListener("error", function (error) {
												blobLoading.reject(error);
											});
											blobReader.readAsText(blob);
										}
										
										blobLoaded.then(cssTxt => {

											let txt = "<base href=\"" + getUrl + "\">";
											let docInRAM = (new DOMParser()).parseFromString(txt, "text/html");
											let aInRAM = docInRAM.createElement("a");
																
											//處理 css 中使用的連結
											let urlsArry = cssTxt.match(/\w+[\s\:]+url\((.*?)(?=\))/g);
											let urls = [];
											$(urlsArry).each((index, url) => {
												if (url.match(/^\b\w+/g)[0] != "import") {
													urls.push(url.match(/url\((.*?)+/g)[0]);
												}
											});
											$(urls).each((index, url) => {
												let lnkString = url.replace("url(", "");
												let lastQuote = $.inArray(lnkString.slice(-1), ["\"", "'"]) > -1 ? lnkString.slice(-1) : "";
												let keyUrl = lastQuote ? lnkString.slice(1, lnkString.length - 1) : lnkString;														
												aInRAM.href = keyUrl;
												let urlArr;
												if(haveToAddChecksumAndDownloadToken){
													urlArr = "url(" + lastQuote + aInRAM.href + "?checksum=" + checksum + "&DownloadToken=" + encodeURIComponent(downloadToken) + lastQuote;
												}else{
													urlArr = "url(" + lastQuote + aInRAM.href + lastQuote;
												}
												let pattern = new RegExp("[\"'-()?=_&~./]");
												let rs = "";
												for (let i = 0; i < url.length; i++) {
													rs += url.slice(i, i + 1).replace(pattern, "\\" + url.substr(i, 1));
												}
												cssTxt = cssTxt.replace(new RegExp(rs, "g"), urlArr);
											});
																
											//處理 css @import 引入的 css
											let imports = cssTxt.match(/\@import (.*?)((.css(?=[\"\)\;])))/g);
											$(imports).each((index, importStr) => {														
												let keyUrl = importStr.split(/[\'\"]/)[1];																												
												let headPart = importStr.replace(keyUrl, "");
												aInRAM.href = keyUrl;
												let urlArr;
												if(haveToAddChecksumAndDownloadToken){
													urlArr = headPart + aInRAM.href + "?checksum=" + checksum + "&DownloadToken=" + encodeURIComponent(downloadToken);
												}else{
													urlArr = headPart + aInRAM.href;
												}
												let pattern = new RegExp("[\"'-()?=_&~./]");
												let rs = "";
												for (let i = 0; i < importStr.length; i++) { //跳脱特殊字符
													rs += importStr.slice(i, i + 1).replace(pattern, "\\" + importStr.substr(i, 1));
												}
												cssTxt = cssTxt.replace(new RegExp(rs, "g"), urlArr);
											});

											blob = new Blob([cssTxt], {type: "text/css"});
											blobLink = window.URL.createObjectURL(blob);
											book.updateBlobCache(getUrl, blobLink);
											$(element).attr(linkAttr, blobLink);
											dfd.resolve();
										}, (err) => {
											console.log(err);
											dfd.resolve();
										});
										break;
									default: 
										blobLink = window.URL.createObjectURL(blob);
										book.updateBlobCache(getUrl, blobLink);
										$(element).attr(linkAttr, blobLink);
										dfd.resolve();
									}
								},
								error:function(err){
									console.log(err);
									dfd.resolve(element);
								}
							});
						}
					}else{
						//if(this.book.settings.encryptType && ( this.book.settings.encryptType === "enc01" || ["img","image"].includes(element.tagName.toLowerCase()))){
							$(element).attr(linkAttr, getUrl);
						//}
					}

				}else{
					//書內, 外連結
					if(!$(element).parent().hasClass('books-audio-fake-image') && !$(element).parent().hasClass('books-audio-fake-image')){
						this.adjustHerf(element, link);
					}
				}
			});
		});

		return Promise.all(promises).then(values => { 

		    //調整img
		    this.adjustImage(doc);
			
			//調整svg
			this.adjustSVG(doc);

			let spineString, spineBlob;
			let spineType = spineUrl.split(/[#?]/)[0].split(".").pop().trim();
			switch(spineType){
				case "xhtml": if(this.book.rendition.settings.manifestCache.spine){
							  	spineString = doc.documentElement.outerHTML;
							  	spineBlob = new Blob([spineString], {type: "application/xhtml+xml"});
							  	this.book.updateBlobCache(spineUrl, spineBlob);
							  }
							  break;
				case "htm":
				case "html":if(this.book.rendition.settings.manifestCache.spine){ 
								spineString = doc.documentElement.outerHTML;
							 	spineBlob = new Blob([spineString], {type: "text/html"});
							 	this.book.updateBlobCache(spineUrl, spineBlob);
							 }
							 break;
			}
			
			return doc;
		});
	}

	adjustSVG(doc){
		$("svg",doc).each((index, svg) => {
			if($(svg).attr("preserveAspectRatio") === "none" && $(svg).attr('width') === "100%" && $(svg).attr('height') === "100%"){
				let children = $(svg).children();
				if(children.length === 1 && children.get(0).tagName.toUpperCase() === "IMAGE"){
					$(svg).removeAttr("preserveAspectRatio");
				}
			}
		});
	}

	adjustImage(doc){
		
		//是否將圖片先隱藏
		if(this.book.rendition._layout.name !== "pre-paginated"){
			$("img, image",doc).each((index, img) => {
				if($(img).attr("src")){
					$(img).attr("data-img-type", "src");
					$(img).attr("data-img-src", $(img).attr("src"));
					$(img).attr("src", "");
				}else{
					$(img).attr("data-img-type", "xlink:href");
					$(img).attr("data-img-src", $(img).attr("xlink:href"));
					$(img).attr("xlink:href", "");
				}
				if($(img).attr("style")){
					$(img).attr("data-img-style", $(img).attr("style"));
				}
				$(img).css("display", "none");
			});
		}
					
	}

	adjustTable(doc){
		$("table",doc).each((index, table) => {
			$(table).attr("id",`table_${index}`);
			let thead = $(table).children("thead");
			let tbody = $(table).children("tbody");
			let tfoot = $(table).children("tfoot");
			let caption = $(table).children("caption");
			if(!thead.length && !tbody.length && !tfoot.length){
				if(caption.length){
					let captionHtml = $('<div>').append(caption.clone()).html();
					caption.remove();
					$(table).html(`${captionHtml}<tbody>${$(table).html()}</tbody>`); 
				}else{
					$(table).html(`<tbody>${$(table).html()}</tbody>`);
				}
			}
		});
	}

	adjustMedia(doc){

		//調整video
		if(this.book.rendition.settings.replaceVideoImage && this.book.rendition.settings.replaceVideoImage !== ""){
			let videoImageUrl = new Url(this.book.rendition.settings.replaceVideoImage);
			$("video",doc).each((index, video) => {
				let isAllowVideo = false;
				let allowVideoExtArr = ["mp4"];
				let ext, src = video.src;

				if (typeof src !== typeof undefined && src !== false && src !== "") {
					ext = src.split(".").pop();
					if ($.inArray(ext, allowVideoExtArr) !== -1) isAllowVideo = true;
				} else {
					$(video).find("source").each(function(){
						ext = $(this).attr("src").split(".").pop();
						if ($.inArray(ext, allowVideoExtArr) !== -1){
							src = $(this)[0].src;
							isAllowVideo = true;
							return false;
						}
					});
				}
				if(isAllowVideo){
					$(video).after(`<div class="books-video-fake-image" data-media-src="${src}" style="cursor: pointer; ${(this.book.rendition.settings.showReplaceMediaImageBG) ? 'background-color:#fff; ':'background-color:transparent; '}border-radius: 10px; width:100%; max-width:200px; max-height:200px; text-align:center; margin:auto auto;">
										<img src="${videoImageUrl.href}" style="width:auto;height:auto;pointer-events:none;"/>
									</div>`);
				}
				$(video).remove();
			});	
		}else{
			$("video",doc).each((index, video) => {
				video.removeAttribute("autoplay");
				video.setAttribute("controlsList","nodownload");
				video.setAttribute("playsinline","true");
				video.setAttribute("webkit-playsinline","true");
				video.setAttribute("style","max-width:100%;");
				if(video.childNodes.length){
					for(let nodeNum = video.childNodes.length -1; nodeNum >= 0; nodeNum--){
						let node = video.childNodes[nodeNum];
						switch(node.nodeType){
							case 1: if(node.tagName !== "source"){
										node.remove();
									}
									break;
							case 3: node.remove();
									break;
						}
					}
				}
			});
		}

		//調整audio
		if(this.book.rendition.settings.replaceAudioImage && this.book.rendition.settings.replaceAudioImage !== ""){
			let audioImageUrl = new Url(this.book.rendition.settings.replaceAudioImage);
			$("audio",doc).each((index, audio) => {
				let isAllowAudio = false;
				let allowAudioExtArr = ["mp3", "mp4", "wav"] ;
				let ext, src = audio.src;
				if (typeof src !== typeof undefined && src !== false && src !== "") {
					ext = src.split(".").pop();
					if ($.inArray(ext, allowAudioExtArr) !== -1) isAllowAudio = true;
				} else {
					$(audio).find("source").each(function(){
						ext = $(this).attr("src").split(".").pop();
						if ($.inArray(ext, allowAudioExtArr) !== -1){
							src = $(this)[0].src;
							isAllowAudio = true;
							return false;
						}
					});
				}
				if(isAllowAudio){
					$(audio).after(`<div class="books-audio-fake-image" data-media-src="${src}" style="cursor: pointer; ${(this.book.rendition.settings.showReplaceMediaImageBG) ? 'background-color:#fff; ':'background-color:transparent; '}border-radius: 10px; width:100%; max-width:200px; max-height:200px; text-align:center; margin:auto auto;">
										<img src="${audioImageUrl.href}" style="width:auto;height:auto;pointer-events:none;"/>
									</div>`);
				}
				$(audio).remove();
			});
		}else{
			$("audio",doc).each((index, audio) => {
				audio.setAttribute("controlsList","nodownload");
				audio.setAttribute("style","max-width:100%;");
				if(audio.innerHTML !== ""){
					for(let nodeNum = audio.childNodes.length -1; nodeNum >= 0; nodeNum--){
						let node = audio.childNodes[nodeNum];
						switch(node.nodeType){
							case 1: if(node.tagName !== "source"){
										node.remove();
									}
									break;
							case 3: node.remove();
									break;
						}
					}
				}
				if($(audio).is(":last-child")){
					$(audio).after(`<p style="opacity:0">.</p>`);
				}
			});
		}

	}

	adjustHerf(element, link){
		if((link && typeof link === "string") && link.search("://") != -1){
			//書外連結
			if(!$(element).parent().attr('data-media-src')){
				element.setAttribute("data-href-type", "outterAllow");
				element.setAttribute("data-href", link);
				element.setAttribute("style", "cursor:pointer;");
				element.removeAttribute("target");
				element.removeAttribute("href");
				element.removeAttribute("xlink:href");
			}
		}else{
			//書內連結
			element.setAttribute("data-href-type", "innerAllow");
		}
	}

	/**
	 * Render the contents of a section
	 * @param  {method} [_request] a request method to use for loading
	 * @return {string} output a serialized XML Document
	 */
	 render(_request){
		var rendering = new defer();
		var rendered = rendering.promise;
		this.output; // TODO: better way to return this from hooks?

		this.load(_request).
			then(function(contents){
				var userAgent = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
				var isIE = userAgent.indexOf('Trident') >= 0;
				var Serializer;
				if (typeof XMLSerializer === "undefined" || isIE) {
					Serializer = XMLDOMSerializer;
				} else {
					Serializer = XMLSerializer;
				}
				var serializer = new Serializer();
				this.output = serializer.serializeToString(contents);
				return this.output;
			}.bind(this)).
			then(function(){
				return this.hooks.serialize.trigger(this.output, this);
			}.bind(this)).
			then(function(){
				rendering.resolve(this.output);
			}.bind(this))
			.catch(function(error){
				rendering.reject(error);
			});

		return rendered;
	}

	findBody(_query){
		var section = this;
		var matches = [];
		var query = _query.toLowerCase();
		var find = function(node){
			var text = node.textContent.toLowerCase();
			var range = section.document.createRange();
			var cfi;
			var pos;
			var last = -1;
			var excerpt;
			var limit = 150;

			while (pos != -1) {
				// Search for the query
				pos = text.indexOf(query, last + 1);

				if (pos != -1) {
					// We found it! Generate a CFI
					range = section.document.createRange();
					range.setStart(node, pos);
					range.setEnd(node, pos + query.length);

					cfi = section.cfiFromRange(range);

					// Generate the excerpt
					if (node.textContent.length < limit) {
						excerpt = node.textContent;
					}
					else {
						excerpt = node.textContent.substring(pos - limit/2, pos + limit/2);
						excerpt = "..." + excerpt + "...";
					}

					// Add the CFI to the matches list
					matches.push({
						cfi: cfi,
						excerpt: excerpt
					});
				}

				last = pos;
			}
		};

		sprint(section.document.body, function(node) {
			find(node);
		});

		return matches;
	};

	destroy() {
		super.destroy();
		this.book = undefined;
	}

}

export default ExSection;